const METADATA_ELEMENT_ID_SEPARATOR = '_' as const;

export const getFullMetadataElementId = (metadataElement: {
  metadataId: string;
  crmOrgId: string;
}) => {
  return `${metadataElement.crmOrgId}${METADATA_ELEMENT_ID_SEPARATOR}${metadataElement.metadataId}`;
};
